// @ts-nocheck
import { Skeleton } from '@mui/material';
import './DesktopSkeleton.css';

const DesktopSkeleton = () => {
  return (
    <div className='desktop-skeleton'>
      {/* Desktop Navigation Skeleton */}
      <div className='desktop-skeleton__navigation'>
        <div className='desktop-skeleton__nav-container'>
          {/* Left side - Logo and Title */}
          <div className='desktop-skeleton__brand'>
            <Skeleton
              variant='rectangular'
              width={80}
              height={50}
              sx={{ borderRadius: '8px' }}
            />
            <Skeleton
              variant='text'
              width={200}
              height={32}
              sx={{ fontSize: '1.5rem' }}
            />
          </div>

          {/* Right side - Navigation tabs */}
          <div className='desktop-skeleton__nav-tabs'>
            {[1, 2, 3, 4].map((index) => (
              <Skeleton
                key={index}
                variant='rectangular'
                width={100}
                height={40}
                sx={{ borderRadius: '12px' }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className='desktop-skeleton__content'>
        <div className='desktop-skeleton__container'>
          {/* Hero Section with Background Image */}
          <div className='desktop-skeleton__hero'>
            <Skeleton
              variant='rectangular'
              width='100%'
              height={500}
              sx={{ borderRadius: '16px' }}
            />

            {/* Overlay Content */}
            <div className='desktop-skeleton__hero-overlay'>
              {/* Date Badge */}
              <div className='desktop-skeleton__date-badge'>
                <Skeleton
                  variant='rectangular'
                  width={150}
                  height={40}
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255,255,255,0.3)'
                  }}
                />
              </div>

              {/* Title */}
              <div className='desktop-skeleton__hero-title'>
                <Skeleton
                  variant='text'
                  width={400}
                  height={60}
                  sx={{
                    fontSize: '3rem',
                    backgroundColor: 'rgba(255,255,255,0.3)'
                  }}
                />
              </div>

              {/* Logo in bottom right */}
              <div className='desktop-skeleton__hero-logo'>
                <Skeleton
                  variant='rectangular'
                  width={120}
                  height={80}
                  sx={{
                    borderRadius: '12px',
                    backgroundColor: 'rgba(255,255,255,0.9)'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Countdown Section */}
          <div className='desktop-skeleton__countdown'>
            <Skeleton
              variant='text'
              width={300}
              height={24}
              sx={{ fontSize: '1rem', margin: '0 auto 2rem' }}
            />

            <div className='desktop-skeleton__countdown-timers'>
              {/* Days */}
              <div className='desktop-skeleton__timer'>
                <Skeleton
                  variant='rectangular'
                  width={80}
                  height={80}
                  sx={{ borderRadius: '12px', marginBottom: '0.5rem' }}
                />
                <Skeleton
                  variant='text'
                  width={60}
                  height={20}
                  sx={{ fontSize: '0.875rem' }}
                />
              </div>

              {/* Hours */}
              <div className='desktop-skeleton__timer'>
                <Skeleton
                  variant='rectangular'
                  width={80}
                  height={80}
                  sx={{ borderRadius: '12px', marginBottom: '0.5rem' }}
                />
                <Skeleton
                  variant='text'
                  width={60}
                  height={20}
                  sx={{ fontSize: '0.875rem' }}
                />
              </div>
            </div>

            <div className='desktop-skeleton__countdown-message'>
              <Skeleton
                variant='text'
                width={200}
                height={20}
                sx={{ fontSize: '0.875rem', margin: '1rem auto' }}
              />
            </div>
          </div>

          {/* Description Section */}
          <div className='desktop-skeleton__description'>
            <Skeleton
              variant='text'
              width='100%'
              height={24}
              sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}
            />
            <Skeleton
              variant='text'
              width='95%'
              height={24}
              sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}
            />
            <Skeleton
              variant='text'
              width='90%'
              height={24}
              sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}
            />
            <Skeleton
              variant='text'
              width='85%'
              height={24}
              sx={{ fontSize: '1rem', marginBottom: '1rem' }}
            />

            {/* Show More Link */}
            <div className='desktop-skeleton__show-more'>
              <Skeleton
                variant='text'
                width={100}
                height={20}
                sx={{ fontSize: '0.875rem', marginLeft: 'auto' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopSkeleton;
